import { ArpeggiSupportedChain } from '@arpeggi/shared'
import axios from 'axios'
import { getAlchemyNetwork } from '../../alchemy'

export const isCollectionHolder = async ({
  userWalletAddress,
  collectionAddress,
  chain
}: {
  userWalletAddress: string
  collectionAddress: string
  chain: ArpeggiSupportedChain
}) => {
  const alchemyChain = getAlchemyNetwork(chain)
  const alchemyAPIKey = window.ALCHEMY_API_KEY
  const url = `https://${alchemyChain}.g.alchemy.com/nft/v2/${alchemyAPIKey}/isHolderOfCollection`
  const { data } = await axios.get<{ isHolderOfCollection: boolean }>(url, {
    params: {
      wallet: userWalletAddress,
      contractAddress: collectionAddress
    }
  })
  return data.isHolderOfCollection
}
